import law from '../settings/law/main'
import office from '../settings/office/main'
import finance from '../settings/finance/main'
import rebase from '../settings/rebase/main'
import bullrun from '../settings/bullrun/main'
import piola from '../settings/piola/main'
import common from '../settings/common/main'
import localhost from '../settings/localhost/main'
import { getPropertyFromPath, getDomain } from './my_utils'

class Settings {
  constructor () {
    this.law = law
    this.office = office
    this.finance = finance
    this.rebase = rebase
    this.bullrun = bullrun
    this.piola = piola
    this.common = common
    this.localhost = localhost
    this.namespace = this.getNamespace()
  }

  get (params) {
    let job_title = params.job_title == undefined ? 'no_job_title' : params.job_title
    try {
      return this.getPropertyFromPath({ context: this[this.namespace][job_title], path: params.path })
    } catch (error) {
      try {
        return this.getPropertyFromPath({ context: this[this.namespace]['common'], path: params.path })
      } catch (error) {
        try {
          return this.getPropertyFromPath({ context: this['common'], path: params.path })
        } catch (error) {
          return ''
        }
      }
    }
  }

  getPropertyFromPath (params) {
    let response = getPropertyFromPath(params)
    if (response == undefined) {
      throw response
    }
    return response
  }

  getNamespace () {
    let domains = {
      'v.sjkgvusgsfjhgfy.rebase.co.il': 'rebase',
      'v.sjkgvusgsfjhgfy.bullrun.co.il': 'bullrun',
      'v.law.sjkgvusgsfjhgfy.suitup.co.il': 'law',
      'v.office.sjkgvusgsfjhgfy.suitup.co.il': 'piola',
      'web.rebase.co.il': 'rebase',
      'suitup.website': 'law',
      'office.suitup.website': 'office',
      'finance.suitup.website': 'finance',
      'rebase.admin.panel.seasideapis.com': 'rebase',
      'law.admin.panel.seasideapis.com': 'law',
      'piola.admin.panel.seasideapis.com': 'piola',
      'localhost': 'localhost'
    }
    let namespace = domains[getDomain()]
    return namespace || 'no_namespace'
  }
}

export default Settings
